export enum PoolRisk {
  LOW = 'LOW',
  MIDDLE = 'MIDDLE',
  HIGH = 'HIGH',
}

export const RISK_OPTIONS = {
  [PoolRisk.LOW]: {
    label: `Under-collateralized pool 1`,
    shortLabel: 'Under-coll. pool 1',
    value: PoolRisk.LOW,
  },

  [PoolRisk.MIDDLE]: {
    label: `Under-collateralized pool`,
    shortLabel: 'Under-coll. pool',
    value: PoolRisk.MIDDLE,
  },

  [PoolRisk.HIGH]: {
    label: `Over-collateralized pool`,
    shortLabel: 'Over-coll. pool',
    value: PoolRisk.HIGH,
  },
} as const

export const POOL_PROJECTED_UTZ = {
  [PoolRisk.LOW]: 0.75,
  [PoolRisk.MIDDLE]: 0.75,
  [PoolRisk.HIGH]: 0.75,
}

export const POOL_PROJECTED_REPAYMENT = {
  [PoolRisk.LOW]: 0.9,
  [PoolRisk.MIDDLE]: 0.9,
  [PoolRisk.HIGH]: 1,
}

export const getPoolShortLabelByRisk = (poolRisk: PoolRisk) => {
  return RISK_OPTIONS[poolRisk].shortLabel
}

export const getApyTooltipText = (poolRisk: PoolRisk) => {
  if (poolRisk === PoolRisk.HIGH) {
    return (
      <>
        Based on the projected APY calculations
        <br />
        when Pool Utilization is {POOL_PROJECTED_UTZ[poolRisk] * 100}%
      </>
    )
  }

  return (
    <>
      Based on the projected APY calculations
      <br />
      when Pool Utilization is {POOL_PROJECTED_UTZ[poolRisk] * 100}% and
      <br />
      Repayment Rate is {POOL_PROJECTED_REPAYMENT[poolRisk] * 100}%
    </>
  )
}
